// src/pages/Leite/propriedade/TemperaturaDialog.jsx
import React, { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    InputAdornment,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import { registrarTemperatura } from '../../../infra/api/Propriedade';
import { mensagemErro } from '../../../infra/api/Coletas';
import { deInputDataHora, paraInputDataHora } from '../../../utils/coleta';

/** Registro do produtor: temperatura do tanque (não há sensor no tanque). */
export default function TemperaturaDialog({ open, onClose, onSalvo }) {
    const [valor, setValor] = useState('');
    const [quando, setQuando] = useState('');
    const [local, setLocal] = useState('');
    const [salvando, setSalvando] = useState(false);
    const [erro, setErro] = useState('');

    useEffect(() => {
        if (!open) return;
        setValor('');
        setQuando(paraInputDataHora(new Date()));
        setLocal('');
        setErro('');
    }, [open]);

    const salvar = async () => {
        const numero = Number(String(valor).replace(',', '.'));
        if (!Number.isFinite(numero)) {
            setErro('Informe a temperatura.');
            return;
        }
        const data = deInputDataHora(quando);
        if (!data) {
            setErro('Informe quando a temperatura foi lida.');
            return;
        }
        setSalvando(true);
        setErro('');
        try {
            await registrarTemperatura({ valorC: numero, dataHora: data.toISOString(), local: local.trim() || null });
            onSalvo();
        } catch (e) {
            setErro(mensagemErro(e, 'Não foi possível registrar a temperatura.'));
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Dialog open={open} onClose={salvando ? undefined : onClose} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle>
                Temperatura do tanque
                <Typography variant="body2" color="text.secondary">Registro do produtor</Typography>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    {erro && <Alert severity="error">{erro}</Alert>}
                    <TextField
                        label="Temperatura"
                        value={valor}
                        onChange={(e) => setValor(e.target.value)}
                        inputProps={{ inputMode: 'decimal' }}
                        InputProps={{ endAdornment: <InputAdornment position="end">°C</InputAdornment> }}
                        autoFocus
                    />
                    <TextField
                        label="Lida em"
                        type="datetime-local"
                        InputLabelProps={{ shrink: true }}
                        value={quando}
                        onChange={(e) => setQuando(e.target.value)}
                    />
                    <TextField label="Tanque (opcional)" value={local} onChange={(e) => setLocal(e.target.value)} inputProps={{ maxLength: 80 }} />
                </Stack>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5 }}>
                <Button onClick={onClose} disabled={salvando}>Cancelar</Button>
                <Button variant="contained" disableElevation onClick={salvar} disabled={salvando} sx={{ borderRadius: 2 }}>
                    {salvando ? 'Salvando…' : 'Registrar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
